/**
 * Decide which editor-config source to fetch. A saved item is always fetched by its id;
 * only an unsaved item (no id) falls back to the asset file name derived from its link.
 *
 * @param {{ itemId?: string, assetFileName?: string }} params
 * @returns {{ kind: 'item', itemId: string } | { kind: 'asset', assetFileName: string } | null}
 */
export function resolveConfigSource({ itemId, assetFileName }) {
  if (itemId) return { kind: 'item', itemId };
  if (assetFileName) return { kind: 'asset', assetFileName };
  return null;
}
